import { render, staticRenderFns } from "./JEditableTable.vue?vue&type=template&id=4f5972b6&scoped=true&"
import script from "./JEditableTable.vue?vue&type=script&lang=js&"
export * from "./JEditableTable.vue?vue&type=script&lang=js&"
import style0 from "./JEditableTable.vue?vue&type=style&index=0&id=4f5972b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5972b6",
  null
  
)

export default component.exports